module.exports = "/packs/as_mv_side-03740c69a28040c1e337bc9c2df81608.jpg";